export const sv = {
  nav: {
    start: "Start",
    losningar: "Våra kunder",
    produkter: "Tjänster",
    kundcase: "Kundcase",
    kunskap: "Kunskap",
    information: "Information",
    nyheter: "Nyheter",
    villkor: "Villkor",
    developer: "Developer",
    omGeposit: "Om Geposit",
    kontakt: "Kontakt",
    bokademo: "Boka demo",
    loggain: "Logga in",
    bestall: "Beställ",
  },
  hero: {
    title: "Geografisk kontroll över din verksamhet",
    subtitle:
      "Validera adresser, hantera geografiska områden och kvalitetssäkra era adressregister i Sverige, Norge, Danmark och Finland – allt i en plattform. För smartare beslut och färre fel i varje led.",
    cta: "Boka demo",
    ctaSecondary: "Se våra lösningar",
  },
  segments: {
    title: "Vilka vi hjälper",
    subtitle:
      "Geposit stödjer verksamheter i Sverige, Norge, Danmark och Finland att effektivisera sin geografiska planering och leveranslogistik.",
    transport: {
      title: "Transport & Logistik",
      description:
        "Definiera leveransområden med postnummerprecision, säkerställ korrekt adressdata och minska returer. Full kontroll över er transportgeografi.",
    },
    service: {
      title: "Service & Installation",
      description:
        "Planera serviceområden, fördela resurser geografiskt och ge era kunder exakta besökstider. Slipp överlappande zoner.",
    },
    ecommerce: {
      title: "E-handel & Omni",
      description:
        "Definiera leveranszoner, validera kundadresser i realtid och optimera er sista-milen-logistik. Färre fel, nöjdare kunder.",
    },
  },
  problems: {
    title: "Känner du igen det här?",
    subtitle: "Många företag kämpar med samma geografiska utmaningar varje dag.",
    items: {
      areas: {
        title: "Otydliga områden",
        description:
          "Geografiska ansvarsområden baseras på magkänsla istället för data. Ingen vet riktigt var gränserna går.",
      },
      addresses: {
        title: "Felaktig adressdata",
        description:
          "Paket kommer tillbaka, servicetekniker hittar inte rätt och kunderna blir frustrerade över förseningar.",
      },
      manual: {
        title: "Manuell planering",
        description:
          "Excel-ark, kartor på väggen och timmar av manuellt arbete för att fördela och uppdatera geografiska områden.",
      },
      overview: {
        title: "Brist på överblick",
        description:
          "Ingen vet riktigt hur de geografiska områdena ser ut eller om de är optimalt fördelade och täcker alla behov.",
      },
    },
  },
  solutions: {
    title: "Så löser Geposit det",
    subtitle:
      "Tre pelare som ger dig kontroll över din geografi och adresskvalitet i hela Norden.",
    pillars: {
      areas: {
        title: "Egna områden med postnummerprecision",
        description:
          "Skapa, visualisera och hantera era geografiska områden med postnummerytor som byggstenar.",
      },
      data: {
        title: "Korrekt adress- & postnummerdata",
        description:
          "Alltid uppdaterad, validerad data som säkerställer att varje adress är korrekt. Minska returer och felkostnader drastiskt.",
      },
      control: {
        title: "Visuell överblick & kontroll över er geografi",
        description:
          "Se hela er geografi på kartan. Analysera, optimera och fatta beslut baserat på data – inte magkänsla.",
      },
    },
  },
  products: {
    title: "Våra tjänster",
    subtitle:
      "Tre kraftfulla verktyg som ger dig kontroll över geografi och adressdata – med full täckning i hela Sverige, Norge, Danmark och Finland.",
    atlas: {
      title: "Atlas",
      description:
        "Skapa och hantera egna geografiska områden för Sverige, Norge, Danmark och Finland. Visualisera, analysera och optimera era geografiska strukturer på en interaktiv karta.",
      cta: "Läs mer om Atlas",
    },
    valid: {
      title: "Valid",
      description:
        "Validera och berika adresser i realtid för alla nordiska länder. Säkerställ att varje adress är korrekt innan den når ert system – via API eller söktjänst i webbgränssnitt.",
      cta: "Läs mer om Valid",
    },
    adresstwatt: {
      title: "Adresstvätt",
      description:
        "Tvätta och kvalitetssäkra era befintliga adressregister i hela Norden. Hitta och korrigera fel i bulk för att förbättra datakvaliteten.",
      cta: "Läs mer om Adresstvätt",
    },
    sisterCompanies: {
      eyebrow: "Systerbolag",
      title: "Våra systerbolag",
      subtitle:
        "Geposit ingår i Progrits-koncernen och samarbetar nära med två systerbolag som kompletterar våra tjänster inom adressdata och transportoptimering.",
      postnummerservice: {
        name: "Postnummerservice",
        description:
          "Postnummerservice har sedan 2005 hjälpt privatpersoner, företag och organisationer i Norden med korrekt och uppdaterad adress-, postnummer- och geodata. Tillsammans levererar vi moderna tjänster byggda på pålitlig grunddata som uppdateras varje vecka.",
        cta: "Besök postnummerservice.se",
      },
      ecoroute: {
        name: "Ecoroute",
        description:
          "Ecoroute erbjuder smarta ruttplanerings- och optimeringslösningar för transport- och servicebolag som vill köra effektivare, mer hållbart och med högre lönsamhet. Tillsammans hjälper vi våra kunder att gå från geografisk planering till genomförd leverans.",
        cta: "Besök ecoroute.com",
      },
    },
  },
  // Product detail pages
  productPages: {
    backToProducts: "Alla tjänster",
    features: "Funktioner",
    benefits: "Fördelar",
    howItWorks: "Så fungerar det",
    ctaTitle: "Redo att komma igång?",
    ctaSubtitle: "Boka en demo eller beställ direkt – vi hjälper er att komma igång snabbt.",
    ctaButton: "Boka demo",
    ctaOrder: "Beställ",
    ctaSecondary: "Kontakta oss",
    atlas: {
      hero: {
        title: "Atlas",
        tagline: "Geografisk områdeshantering",
        subtitle:
          "Skapa, visualisera och hantera era egna geografiska områden på en interaktiv karta. Definiera säljdistrikt, leveranszoner och serviceområden med postnummerprecision – i Sverige, Norge, Danmark och Finland.",
      },
      overview:
        "Atlas är Geposits karttjänst för att skapa och hantera egna geografiska områden i hela Norden. Bygg upp era områden med postnummerytor som byggstenar, rita frihand eller importera befintliga strukturer. Visualisera data som heat maps, mät avstånd och dela kartor med hela organisationen – via iFrame eller API. Atlas stödjer Sverige, Norge, Danmark och Finland.",
      featureGroups: {
        createAndVisualize: "Skapa & visualisera med postnummer",
        calculateAndAnalyze: "Mät & analysera",
        integrateAndShare: "Integrera & dela",
      },
      features: {
        title: "Allt du behöver för geografisk planering",
        subtitle:
          "Atlas ger er verktygen att ta kontroll över era geografiska strukturer – enkelt, visuellt och datadrivet.",
        items: {
          points: {
            title: "Punkter på karta",
            description:
              "Placera punkter med adress eller koordinat. Visualisera kunddata, lager eller servicepunkter – enskilt eller som heat map.",
          },
          areas: {
            title: "Egna områden med postnummer",
            description:
              "Bygg upp områden med postnummerytor som byggstenar – varje postnummer snäpper på plats som en pusselbit. Rita frihand, importera shapefiler eller kombinera metoder för full flexibilitet.",
          },
          heatmaps: {
            title: "Heat maps",
            description:
              "Visualisera datamönster geografiskt med heat maps. Se koncentrationer av kunder, leveranser eller servicebehov direkt på kartan.",
          },
          routes: {
            title: "Avståndsberäkning",
            description:
              "Beräkna avstånd och restid mellan punkter. Välj fordonstyp för realistiska uppskattningar – ett stöd vid planering av serviceområden och upptagningszoner.",
          },
          measure: {
            title: "Mätverktyg",
            description:
              "Använd räckviddscirklar för att mäta avstånd från en punkt. Perfekt för att definiera upptagningsområden eller serviceradie.",
          },
          attributes: {
            title: "Attribut & metadata",
            description:
              "Koppla er egen data till områden och punkter. Lägg till priszoner, ansvariga säljare, kapacitet eller andra affärsregler.",
          },
          iframe: {
            title: "iFrame-delning",
            description:
              "Bädda in era kartor direkt på en webbplats eller i ett internt system. Ge kollegor och partners tillgång utan inloggning.",
          },
          api: {
            title: "API-integration",
            description:
              "Hämta och skicka data programmatiskt via REST API. Integrera Atlas med ert CRM, ERP, transportsystem eller BI-plattform.",
          },
        },
      },
      useCases: {
        title: "Användningsområden",
        items: {
          salesDistricts: {
            title: "Säljdistrikt",
            description:
              "Definiera och visualisera säljares ansvarsområden. Se täckning, identifiera luckor och balansera arbetsbelastningen.",
          },
          deliveryZones: {
            title: "Leveranszoner",
            description:
              "Skapa tydliga leveransområden per terminal, chaufför eller region. Alla ser samma bild.",
          },
          priceZones: {
            title: "Priszoner",
            description:
              "Definiera geografiska zoner med olika prissättning. Koppla till ert affärssystem för automatisk prisberäkning.",
          },
          biConnection: {
            title: "BI & analys",
            description:
              "Exportera geodata till ert BI-verktyg eller koppla direkt via API. Geografisk dimension i era rapporter.",
          },
          distanceCalc: {
            title: "Avståndsberäkning",
            description:
              "Beräkna avstånd och restider mellan punkter med olika fordonstyper. Ett stöd vid planering och schemaläggning.",
          },
          crmConnection: {
            title: "CRM-koppling",
            description:
              "Synkronisera geografiska områden med ert CRM-system. Automatisk tilldelning av kunder till rätt säljare.",
          },
        },
      },
      benefits: {
        title: "Varför Atlas?",
        items: {
          time: {
            title: "Spara tid",
            description:
              "Slipp manuella Excel-ark och papperskartor. Gör på minuter vad som tidigare tog timmar.",
          },
          decisions: {
            title: "Bättre beslut",
            description:
              "Basera era geografiska beslut på data istället för magkänsla. Se mönster och optimeringsmöjligheter direkt.",
          },
          overview: {
            title: "Full överblick",
            description:
              "Alla i organisationen ser samma bild. Inga fler oklarheter om var gränserna går.",
          },
        },
      },
      howItWorks: {
        steps: {
          first: {
            title: "Importera er data",
            description:
              "Ladda upp era befintliga områden, adresser eller koordinater. Atlas stödjer shapefiler, CSV och API-import.",
          },
          second: {
            title: "Skapa och anpassa",
            description:
              "Bygg områden med postnummerytor som byggstenar, rita frihand, visualisera med heat maps och mät avstånd.",
          },
          third: {
            title: "Dela och integrera",
            description:
              "Publicera kartor via iFrame, exportera data eller koppla till era system via API.",
          },
        },
      },
      pricing: {
        features: {
          binding12: "12 månaders bindningstid",
          adminMapCountry: "1 admin, 1 karta, 1 land",
          importData: "Importera egen data på karta",
          manageAreas: "Skapa, visa och hantera områden",
          apiIntegration: "Integrera till dina system via API",
          export2000: "Exportera 2 000 postnummer/mån",
          exportUnlimited: "Exportera obegränsat med postnummer",
          routingIncluded: "Routing Small inkluderat",
        },
        plans: {
          small: {
            name: "SMALL",
            price: "1 795 SEK",
          },
          medium: {
            name: "MEDIUM",
            price: "2 995 SEK",
          },
          medium3: {
            name: "MEDIUM 3-MÅN",
            price: "3 595 SEK",
          },
        },
        addons: {
          extraCountry: { name: "Extra land", price: "1 000 SEK/mån" },
          extraMap: { name: "Extra karta", price: "495 SEK/mån" },
          extraAdmin: { name: "Extra admin-användare", price: "295 SEK/mån" },
          extraViewer: { name: "Extra titt-användare", price: "95 SEK/mån" },
          exportPostal: { name: "Export postnummer", small: "0,80 SEK/st", mediumPlus: "Ingår" },
          exportCoords: { name: "Export koordinater", small: "1,00 SEK/st", mediumPlus: "0,90 SEK/st" },
        },
      },
      workflow: {
        title: "Se hur Atlas fungerar",
        subtitle: "Utforska tre olika användningsområden och se hur Atlas kan effektivisera era arbetsflöden.",
        tabs: {
          responsibility: "Ansvarsområden",
          pricing: "Priszoner",
          analytics: "Analys & BI",
        },
        responsibility: {
          step1: "Plotta punkter",
          step2: "Rita ansvarsområden",
          step3: "Namnge områden",
          step4: "Lägg till attribut",
          step5: "Koppla till CRM",
          step6: "Ärende inkommer",
          step7: "Atlas identifierar ansvarig",
          step8: "Automatisk tilldelning",
        },
        pricing: {
          step1: "Plotta lagerplatser",
          step2: "Definiera leveranszoner",
          step3: "Ange pris per zon",
          step4: "Koppla till TMS",
          step5: "Leveransförfrågan inkommer",
          step6: "Atlas returnerar pris",
        },
        analytics: {
          step1: "Plotta intressepunkter",
          step2: "Definiera analysområden",
          step3: "Mät avstånd",
          step4: "Visualisera med heatmaps",
          step5: "Integrera med BI-system",
        },
      },
      routing: {
        title: "Routing",
        subtitle: "Tilläggstjänst till Atlas för körvägsberäkning och räckviddsanalys. Beräkna rutter, körtider och räckviddsområden – och skapa ännu mer realistiska områdesindelningar.",
        routes: {
          title: "Körvägsberäkning",
          description: "Beräkna körtider, köravstånd och optimala rutter mellan punkter på kartan. Stöd för multi-stopp och olika fordonstyper för realistiska uppskattningar.",
        },
        reach: {
          title: "Räckviddsområden",
          description: "Beräkna och visualisera hur stor geografisk yta du kan nå inom en viss tid från en given punkt. Perfekt för att skapa realistiska ansvarsområden och upptagningszoner.",
        },
        tabs: {
          routes: "Körvägar",
          reach: "Räckvidd",
        },
        tiers: {
          sectionTitle: "Routing-paket",
          included: "Routing Small ingår i Atlas Medium och Atlas Medium 3-mån. Atlas Small-kunder kan lägga till Routing som komplement.",
          volumeTitle: "Inkluderade volymer",
          small: {
            name: "Small",
            price: "495 SEK/mån",
            features: [
              "Beräkna köravstånd och körtid mellan två punkter",
              "Analysera och skapa räckviddsområden",
            ],
            volumes: [
              "10 000 route-anrop/mån",
              "250 räckviddsberäkningar/mån",
            ],
          },
          medium: {
            name: "Medium",
            price: "995 SEK/mån",
            features: [
              "Beräkna köravstånd och körtid mellan två eller flera punkter",
              "Analysera och skapa räckviddsområden",
              "Optimera ruttplanering mellan flera punkter (multi-stopp)",
              "Avancerade transport- och fordonskonfigurationer",
            ],
            volumes: [
              "15 000 route-anrop/mån",
              "1 000 räckviddsberäkningar/mån",
              "5 000 optimize-anrop/mån",
            ],
          },
          large: {
            name: "Large",
            price: "1 495 SEK/mån",
            features: [
              "Beräkna köravstånd och körtid mellan två eller flera punkter",
              "Analysera och skapa räckviddsområden",
              "Optimera ruttplanering mellan flera punkter (multi-stopp)",
              "Avancerade transport- och fordonskonfigurationer",
            ],
            volumes: [
              "25 000 route-anrop/mån",
              "2 500 räckviddsberäkningar/mån",
              "10 000 optimize-anrop/mån",
            ],
          },
        },
      },
    },
    valid: {
      hero: {
        title: "Valid",
        tagline: "Adressvalidering & berikning",
        subtitle:
          "Validera, korrigera och berika adresser i realtid för Sverige, Norge, Danmark och Finland. Via API, autocomplete i formulär eller söktjänst i webbgränssnitt – Valid säkerställer korrekt adressdata i varje steg.",
      },
      overview:
        "Valid är Geposits tjänst för adressvalidering, autocomplete och berikning med komplett nordisk täckning. Kontrollera om en adress finns i Sverige, Norge, Danmark eller Finland, ge användaren smarta förslag medan de skriver, och berika varje adress med över 10 geografiska attribut. Tillgänglig via REST API eller som söktjänst i webbgränssnitt.",
      featureGroups: {
        api: "API-tjänster",
        web: "Webbgränssnitt",
      },
      features: {
        title: "Korrekt adressdata – varje gång",
        subtitle:
          "Valid fångar fel innan de blir problem. Integrera i era system eller använd söktjänsten direkt i webbläsaren.",
        items: {
          validation: {
            title: "Adressvalidering",
            description:
              "Kontrollera om en adress finns och är korrekt. Få omedelbar feedback med statusindikering och förslag på korrigering.",
          },
          autocomplete: {
            title: "Autocomplete",
            description:
              "Ge användaren smarta adressförslag i realtid medan de skriver. Snabbare ifyllning, färre fel, bättre användarupplevelse.",
          },
          enrichment: {
            title: "Berikning",
            description:
              "Komplettera varje adress med över 10 attribut: län, kommun, distrikt, församling, koordinater, fastighetsbeteckning, DeSO/RegSO med mera.",
          },
          search: {
            title: "Söktjänst i webbgränssnitt",
            description:
              "Sök och verifiera adresser direkt i Geposits webbgränssnitt – utan att behöva integrera via API. Perfekt för manuell kontroll.",
          },
          coverage: {
            title: "Nordisk täckning",
            description:
              "Komplett adressdatabas för Sverige, Norge, Danmark och Finland. Uppdateras varje vecka med data från officiella grundkällor.",
          },
        },
      },
      enrichmentData: {
        title: "Berikningsattribut",
        subtitle:
          "Varje validerad adress kan berikas med följande geografiska och administrativa attribut.",
        items: {
          county: {
            name: "Län",
            description: "Administrativt län som adressen tillhör",
          },
          municipality: {
            name: "Kommun",
            description: "Kommun som adressen är registrerad i",
          },
          district: {
            name: "Distrikt",
            description: "Geografiskt distrikt inom kommunen",
          },
          parish: {
            name: "Församling",
            description: "Kyrklig församling för adressen",
          },
          lkfCode: {
            name: "LKF-kod",
            description:
              "Statistisk områdeskod (Län, Kommun, Församling)",
          },
          municipalityCode: {
            name: "Kommunkod",
            description: "Officiell numerisk kommunkod",
          },
          property: {
            name: "Fastighetsbeteckning",
            description:
              "Officiell fastighetsbeteckning från Lantmäteriet",
          },
          coordinates: {
            name: "Koordinater",
            description:
              "Latitud och longitud (WGS84) för adressen",
          },
          deso: {
            name: "DeSO",
            description: "Demografiskt statistikområde (SCB)",
          },
          regso: {
            name: "RegSO",
            description: "Regionalt statistikområde (SCB)",
          },
          uuid: {
            name: "UUID",
            description: "Unik identifierare för adressen",
          },
          postalCode: {
            name: "Postnummer",
            description: "Verifierat och aktuellt postnummer",
          },
          city: {
            name: "Postort",
            description:
              "Officiell postort kopplad till postnumret",
          },
        },
      },
      useCases: {
        title: "Användningsområden",
        items: {
          checkout: {
            title: "E-handel checkout",
            description:
              "Integrera autocomplete och validering i kassan. Kunden fyller i rätt adress direkt – färre returer, snabbare leverans.",
          },
          booking: {
            title: "Bokningsportaler",
            description:
              "Säkerställ korrekta adresser vid servicebokning. Teknikern hittar rätt direkt utan onödiga samtal.",
          },
          systemIntegration: {
            title: "Systemintegration",
            description:
              "Validera och berika adresser vid import till CRM, ERP eller marknadsföringssystem. Säkerställ datakvalitet från start.",
          },
          crmQuality: {
            title: "CRM-kvalitet",
            description:
              "Kör era kundregister genom Valid för att identifiera och korrigera felaktiga adresser. Bättre data, bättre beslut.",
          },
        },
      },
      benefits: {
        title: "Varför Valid?",
        items: {
          returns: {
            title: "Färre returer",
            description:
              "Korrekt adressdata från start innebär färre brev och paket som kommer tillbaka.",
          },
          experience: {
            title: "Bättre kundupplevelse",
            description:
              "Snabbare formulär med autocomplete och direkt validering. Era kunder uppskattar det.",
          },
          costs: {
            title: "Sänkta kostnader",
            description:
              "Varje felaktig adress kostar er pengar. Valid betalar sig själv genom minskade felkostnader.",
          },
        },
      },
      howItWorks: {
        steps: {
          first: {
            title: "Integrera eller sök",
            description:
              "Koppla Valid till ert system via REST API, eller använd söktjänsten direkt i webbgränssnittet.",
          },
          second: {
            title: "Validera och berika",
            description:
              "Adresser valideras i realtid. Felaktiga adresser korrigeras och berikas med 10+ attribut automatiskt.",
          },
          third: {
            title: "Korrekt data – alltid",
            description:
              "Varje adress i ert system är verifierad, komplett och kopplad till aktuell geografisk data.",
          },
        },
      },
      demo: {
        title: "Testa Valid",
        subtitle: "Prova tjänsten direkt – välj land, skriv en adress och se hur Valid validerar, föreslår och berikar i realtid.",
        countryLabel: "Välj land:",
        countries: {
          se: "Sverige",
          no: "Norge",
          dk: "Danmark",
          fi: "Finland",
        },
        tabs: {
          autocomplete: "Autocomplete",
          validate: "Validera",
          enrich: "Berika",
        },
        autocomplete: {
          description: "Börja skriv en adress och se förslag i realtid. Välj ett förslag för att fylla i adressen.",
          placeholder: "Börja skriv en adress…",
          selected: "Vald adress",
        },
        validate: {
          description: "Skriv in en adress och klicka på Validera för att kontrollera om den finns och är korrekt.",
          streetLabel: "Gatuadress",
          streetPlaceholder: "t.ex. Storgatan 1",
          postcodeLabel: "Postnummer",
          postcodePlaceholder: "t.ex. 111 22",
          localityLabel: "Ort",
          localityPlaceholder: "t.ex. Stockholm",
          button: "Validera adress",
          validMessage: "Adressen är korrekt!",
          invalidMessage: "Adressen kunde inte valideras",
          suggestions: "Menade du kanske:",
        },
        enrich: {
          description: "Skriv in en adress och klicka på Berika för att se all tillhörande geografisk och administrativ data.",
          button: "Berika adress",
          errorMessage: "Adressen kunde inte berikas. Kontrollera att den är korrekt.",
        },
      },
      pricing: {
        features: {
          nordicValidation: "Validering av adresser i hela Norden",
          autocomplete: "Autocomplete för gatunamn, postnummer och postorter",
          adminControl: "Kontroll av län, kommun, församling och distrikt",
        },
        details: {
          validationsIncluded: "Valideringar/mån",
          autocompleteIncluded: "Autocomplete/mån",
          extraValidation: "Överskjutande validering",
          extraAutocomplete: "Överskjutande autocomplete",
        },
        plans: {
          small: {
            name: "SMALL",
            price: "695 SEK",
            validations: "1 000",
            autocomplete: "7 500",
            extraValidation: "0,50 SEK",
            extraAutocomplete: "0,07 SEK",
          },
          medium: {
            name: "MEDIUM",
            price: "1 795 SEK",
            validations: "6 000",
            autocomplete: "45 000",
            extraValidation: "0,35 SEK",
            extraAutocomplete: "0,05 SEK",
          },
          large: {
            name: "LARGE",
            price: "3 995 SEK",
            validations: "20 000",
            autocomplete: "150 000",
            extraValidation: "0,25 SEK",
            extraAutocomplete: "0,03 SEK",
          },
          xl: {
            name: "XL",
            price: "5 995 SEK",
            validations: "40 000",
            autocomplete: "300 000",
            extraValidation: "0,15 SEK",
            extraAutocomplete: "0,01 SEK",
          },
        },
        addons: {
          geocodePostal: { name: "Geokodning postnummer", small: "1,00 SEK/st", medium: "0,90 SEK/st", large: "0,80 SEK/st", xl: "0,70 SEK/st" },
          geocodeAddress: { name: "Geokodning adress", small: "Enligt offert", medium: "Enligt offert", large: "Enligt offert", xl: "Enligt offert" },
          uuid: { name: "UUID", small: "0,10 SEK/st", medium: "0,08 SEK/st", large: "0,06 SEK/st", xl: "0,04 SEK/st" },
          property: { name: "Fastighetsbeteckning", small: "0,50 SEK/st", medium: "0,40 SEK/st", large: "0,30 SEK/st", xl: "0,20 SEK/st" },
          desoRegso: { name: "DeSO/RegSO", small: "0,60 SEK/st", medium: "0,50 SEK/st", large: "0,40 SEK/st", xl: "0,30 SEK/st" },
        },
      },
    },
    adresstwatt: {
      hero: {
        title: "Adresstvätt",
        tagline: "Vård av adressregister",
        subtitle:
          "Skicka in ert adressregister – få tillbaka en tvättad, korrigerad och berikad version. Vi identifierar felaktiga adresser, dubbletter och inaktuella uppgifter i Sverige, Norge, Danmark och Finland.",
      },
      overview:
        "Adresstvätt är Geposits tjänst för att kvalitetssäkra befintliga adressregister i hela Norden. Ni skickar in ert register i valfritt format, och vi analyserar varje adress mot vår uppdaterade databas för Sverige, Norge, Danmark och Finland. Felaktiga adresser korrigeras, dubbletter identifieras och varje adress berikas med samma attribut som Valid levererar – från län och kommun till koordinater och DeSO/RegSO.",
      featureGroups: {
        analyze: "Analysera & identifiera",
        correctAndEnrich: "Korrigera & berika",
      },
      features: {
        title: "Ren adressdata – i hela registret",
        subtitle:
          "Adresstvätt tar hand om era befintliga adressdata och ser till att de håller hög kvalitet.",
        items: {
          analyze: {
            title: "Registeranalys",
            description:
              "Vi analyserar ert befintliga register och identifierar felaktiga, ofullständiga och inaktuella adresser. Ni får en komplett kvalitetsrapport.",
          },
          correct: {
            title: "Korrigering mot officiell data",
            description:
              "Felaktiga adresser korrigeras automatiskt mot vår uppdaterade databas med officiella adresser från nordiska grundkällor.",
          },
          duplicates: {
            title: "Dublettrensning",
            description:
              "Identifiera och hantera dubbletter i era register. Slå ihop, markera eller ta bort för att få ett rent kundregister.",
          },
          enrich: {
            title: "Berikning med attribut",
            description:
              "Varje adress berikas med samma attribut som Valid: län, kommun, koordinater, fastighetsbeteckning, DeSO/RegSO med mera.",
          },
          report: {
            title: "Kvalitetsrapport",
            description:
              "Få en detaljerad rapport med statistik över antalet korrigerade, borttagna och berikade adresser. Se exakt vad som gjorts.",
          },
          flexible: {
            title: "Flexibla format",
            description:
              "Skicka in era adresser i CSV, Excel eller via API. Få tillbaka den tvättade versionen i samma format – redo att importera.",
          },
        },
      },
      useCases: {
        title: "Användningsområden",
        items: {
          registerCare: {
            title: "Registervård",
            description:
              "Regelbunden tvätt av kundregister för att hålla datakvaliteten hög. Kör kvartalsvis eller inför viktiga kampanjer.",
          },
          campaigns: {
            title: "Kampanjutskick",
            description:
              "Tvätta registret innan fysiska utskick. Undvik kostnaden för brev som inte når fram på grund av felaktiga adresser.",
          },
          gdpr: {
            title: "GDPR & datakvalitet",
            description:
              "Identifiera och rensa inaktuella adresser som en del av ert GDPR-arbete. Håll bara den data ni faktiskt behöver.",
          },
        },
      },
      benefits: {
        title: "Varför Adresstvätt?",
        items: {
          quality: {
            title: "Högre datakvalitet",
            description:
              "Ett rent adressregister är grunden för all logistik, marknadsföring och kundkommunikation.",
          },
          savings: {
            title: "Direkta besparingar",
            description:
              "Varje korrigerad adress minskar kostnaden för returer, felutskick och manuell hantering.",
          },
          compliance: {
            title: "Bättre kunddata",
            description:
              "Korrekta adresser förbättrar er CRM-data och ger bättre underlag för affärsbeslut.",
          },
        },
      },
      howItWorks: {
        steps: {
          first: {
            title: "Skicka in ert register",
            description:
              "Ladda upp ert adressregister i CSV, Excel eller via API. Vi stödjer alla vanliga format.",
          },
          second: {
            title: "Vi analyserar och tvättar",
            description:
              "Varje adress kontrolleras, korrigeras mot officiell data, berikas med attribut och dubbletter rensas.",
          },
          third: {
            title: "Få tillbaka rent register",
            description:
              "Ni får ert register tillbaka – korrigerat, berikat och med en detaljerad kvalitetsrapport.",
          },
        },
      },
      pricing: {
        tagline: "PRISER",
        title: "Enkel och transparent prissättning",
        subtitle: "Börja med en kostnadsfri analys av ert register. Vill ni gå vidare med en full tvätt betalar ni per adressrad – ju fler adresser, desto lägre pris.",
        descriptionCol: "Beskrivning",
        freeAnalysis: "Gratis analys",
        fullWash: "Adresstvätt",
        volumeCol: "Volym",
        setupFee: "Startavgift",
        setupFreeValue: "0 SEK",
        setupWashValue: "500 SEK",
        rows: "adressrader",
        features: {
          statistics: "Statistik – sammanställning av antal felaktiga adresser och vilka fel som bör korrigeras",
          identify: "Identifiering av vilka adresser som är felaktiga",
          correct: "Felaktiga adresser rättas mot officiella källor",
          split: "Gatuadressen uppdelad i gatunamn, nummer, bokstav etc.",
          suggest: "Förslag på korrekt adress vid flera möjliga matchningar",
          enrich: "Adresserna kompletteras med län, kommun och församling",
        },
        tiers: {
          tier1: { free: "Ingen kostnad", wash: "0,30 SEK/rad" },
          tier2: { free: "Ingen kostnad", wash: "0,20 SEK/rad" },
          tier3: { free: "Ingen kostnad", wash: "0,10 SEK/rad" },
        },
      },
    },
    pricing: {
      tagline: "PAKET OCH PRISER",
      title: "Välj det paket som passar er",
      subtitle: "Alla paket inkluderar support och tillgång till vår dokumentation. Välj det paket som passar dig och kontakta oss vid frågor eller funderingar.",
      recommended: "Rekommenderat",
      cta: "Kom igång",
      ctaHighlighted: "Kom igång",
      showAddons: "Visa tillval och rörliga priser",
      hideAddons: "Dölj tillval",
      addonColumn: "Tillval",
      perMonth: "/ mån",
      shortBinding: "3 mån bindningstid",
    },
  },
  // Solution pages
  solutionPages: {
    backToSolutions: "Alla lösningar",
    ctaButton: "Boka demo",
    ctaSecondary: "Se våra tjänster",
    readMore: "Läs mer",
    overview: {
      tagline: "LÖSNINGAR",
      title: "Lösningar för din bransch",
      subtitle: "Oavsett om du arbetar med transport, service eller e-handel – Geposit ger dig verktygen att optimera din geografi och adressdata.",
      segments: {
        transport: {
          title: "Transport & Logistik",
          description: "Optimera leveransområden, minska returer och säkerställ att varje leverans når rätt adress. Definiera egna zoner och få full kontroll över er transportgeografi.",
        },
        service: {
          title: "Service & Installation",
          description: "Planera serviceområden utan överlapp, fördela resurser effektivt och ge era kunder exakta besökstider baserat på geografisk data.",
        },
        ecommerce: {
          title: "E-handel & Omni",
          description: "Validera kundadresser i realtid, definiera leveranszoner och optimera er sista-milen-logistik för nöjdare kunder och färre returer.",
        },
      },
      cta: {
        title: "Osäker på vilken lösning som passar?",
        subtitle: "Kontakta oss så hjälper vi dig att hitta rätt lösning för just din verksamhet.",
      },
    },
    transport: {
      hero: {
        tagline: "Transport & Logistik",
        title: "Effektivare leveranser med geografisk kontroll",
        subtitle: "Definiera leveransområden med postnummerprecision, säkerställ korrekt adressdata och minska returer – så att varje leverans når rätt mottagare, i rätt tid. Med Geposit får ni konkreta verktyg för zonhantering och adressvalidering.",
      },
      challenges: {
        title: "Utmaningar inom transport",
        subtitle: "Transportbolag kämpar dagligen med geografiska och adressrelaterade problem som kostar tid och pengar. Utan rätt verktyg blir konsekvenserna dyra.",
        items: {
          zones: {
            title: "Oklara leveranszoner",
            description: "Utan tydligt definierade leveransområden hamnar paket fel, zoner överlappar och chauffören förlorar tid på att reda ut gränsdragningar.",
          },
          routes: {
            title: "Oklara gränsdragningar",
            description: "Utan datadriven zonplanering baseras ansvarsområden på magkänsla istället för data. Det leder till överlappande zoner och luckor i täckningen.",
          },
          returns: {
            title: "Höga returkostnader",
            description: "Felaktiga eller ofullständiga adresser leder till misslyckade leveranser. Varje retur kostar pengar och försämrar kundupplevelsen.",
          },
        },
      },
      solutions: {
        title: "Så hjälper Geposit transportbolag",
        subtitle: "Med rätt verktyg kan ni ta kontroll över er leveransgeografi och minska kostsamma fel.",
        items: {
          areas: {
            title: "Definiera leveransområden i Atlas",
            description: "Skapa och visualisera era egna leveranszoner i Atlas med postnummerytor som byggstenar. Inga fler oklara gränser – alla ser samma bild och vet exakt vilka områden de ansvarar för.",
          },
          data: {
            title: "Validera adresser med Valid",
            description: "Med Valid valideras varje adress innan leverans. Felaktiga adresser fångas direkt vid inmatning, och ni slipper kostsamma returer på grund av adressfel.",
          },
          optimize: {
            title: "Håll registret rent med Adresstvätt",
            description: "Tvätta era kundregister regelbundet med Adresstvätt. Analysera era leveransområden med underlagsdata och säkerställ att zonindelningen matchar verkligheten.",
          },
        },
      },
      products: {
        title: "Tjänster för transport",
        subtitle: "Tre verktyg som tillsammans ger er full kontroll över leveransgeografi och adresskvalitet.",
        items: {
          atlas: {
            name: "Atlas",
            description: "Skapa, visualisera och hantera era leveranszoner med postnummerytor som byggstenar. Definiera områden per chaufför, terminal eller region – allt på en interaktiv karta.",
          },
          valid: {
            name: "Valid",
            description: "Validera leveransadresser i realtid. Fånga felaktiga adresser innan paketet lämnar terminalen och undvik dyra returer.",
          },
          adresstwatt: {
            name: "Adresstvätt",
            description: "Tvätta era kundregister regelbundet för att hålla adressdata korrekt och uppdaterad. Minska felkostnader och höj leveransprecisionen.",
          },
        },
      },
      cta: {
        title: "Redo att effektivisera era leveranser?",
        subtitle: "Boka en demo och se hur Geposit kan hjälpa ert transportbolag att minska returer och optimera leveransområden.",
      },
    },
    service: {
      hero: {
        tagline: "Service & Installation",
        title: "Smartare planering av serviceområden",
        subtitle: "Fördela resurser geografiskt, eliminera överlappande zoner och ge era kunder exakta besökstider – med Atlas, Valid och Adresstvätt som grund.",
      },
      challenges: {
        title: "Utmaningar inom service",
        subtitle: "Servicebolag och installationsföretag möter dagligen geografiska utmaningar som påverkar effektivitet och kundnöjdhet. Rätt verktyg gör skillnaden.",
        items: {
          overlap: {
            title: "Överlappande zoner",
            description: "Utan tydliga gränser mellan serviceområden riskerar ni att skicka flera tekniker till samma område, medan andra områden blir underbemannade.",
          },
          resources: {
            title: "Ojämn resursfördelning",
            description: "Vissa tekniker har för stora områden, andra för små. Utan geografisk analys baseras fördelningen på magkänsla istället för data.",
          },
          scheduling: {
            title: "Oprecis tidsplanering",
            description: "Utan korrekta adresser och avståndsberäkningar blir tidsfönster opålitliga, vilket leder till missnöjda kunder och ineffektiv schemaläggning.",
          },
        },
      },
      solutions: {
        title: "Så hjälper Geposit servicebolag",
        subtitle: "Med Geposits verktyg kan ni planera, visualisera och optimera era serviceområden utifrån data.",
        items: {
          zones: {
            title: "Tydliga serviceområden i Atlas",
            description: "Definiera exakta serviceområden i Atlas med postnummerytor som byggstenar – inga överlapp, inga luckor. Varje tekniker vet exakt sitt ansvarsområde och ser det på kartan.",
          },
          address: {
            title: "Hitta rätt med Valid",
            description: "Med Valid säkerställs att varje kundadress är korrekt vid bokning. Teknikern hittar rätt direkt, och ni slipper kostsamma bomkörningar.",
          },
          balance: {
            title: "Ren data med Adresstvätt",
            description: "Tvätta era kundregister med Adresstvätt och analysera era serviceområden med underlagsdata som antal kunder, avstånd och restider.",
          },
        },
      },
      products: {
        title: "Tjänster för service",
        subtitle: "Verktyg som ger ert serviceteam rätt förutsättningar från start.",
        items: {
          atlas: {
            name: "Atlas",
            description: "Skapa och hantera serviceområden visuellt med postnummer som grund. Fördela tekniker per zon och se hela er servicegeografi på en karta.",
          },
          valid: {
            name: "Valid",
            description: "Validera kundadresser vid bokning. Undvik bomkörningar genom att säkerställa att varje serviceadress är korrekt.",
          },
          adresstwatt: {
            name: "Adresstvätt",
            description: "Rensa ert kundregister från felaktiga adresser. Se till att er serviceplattform bygger på korrekt och uppdaterad data.",
          },
        },
      },
      cta: {
        title: "Redo att optimera era serviceområden?",
        subtitle: "Boka en demo och se hur Geposit kan hjälpa ert servicebolag att planera smartare och leverera bättre.",
      },
    },
    ecommerce: {
      hero: {
        tagline: "E-handel & Omni",
        title: "Perfekt leverans i varje kanal",
        subtitle: "Validera kundadresser direkt i kassan, definiera leveranszoner och säkerställ att varje order når rätt mottagare – oavsett kanal. Med Valid, Atlas och Adresstvätt.",
      },
      challenges: {
        title: "Utmaningar inom e-handel",
        subtitle: "E-handlare och omnikanalföretag kämpar med adresskvalitet och leveransprecision i en alltmer krävande marknad. Konsekvenserna är kostsamma.",
        items: {
          delivery: {
            title: "Otydliga leveranszoner",
            description: "Utan definierade leveransområden är det svårt att erbjuda differentierade fraktalternativ och pris per zon till era kunder.",
          },
          returns: {
            title: "Returer på grund av adressfel",
            description: "Kunder skriver in felaktiga adresser, och utan validering skickas paketet ändå. Resultatet: returer, kostnader och missnöjda kunder.",
          },
          expansion: {
            title: "Nordisk expansion",
            description: "Att expandera till nya nordiska marknader kräver korrekt adressdata för varje land. Felaktig data hindrar tillväxt och ökar kostnaderna.",
          },
        },
      },
      solutions: {
        title: "Så hjälper Geposit e-handlare",
        subtitle: "Med rätt data och verktyg kan ni minska returer, förbättra kundupplevelsen och expandera tryggare.",
        items: {
          zones: {
            title: "Smarta leveranszoner i Atlas",
            description: "Definiera era leveransområden i Atlas med postnummerytor och koppla dem till era fraktalternativ. Erbjud rätt leveransval baserat på kundens adress – automatiskt.",
          },
          validation: {
            title: "Adressvalidering med Valid i kassan",
            description: "Med Valid valideras kundens adress direkt vid inmatning. Autocomplete ger smarta förslag och felaktiga adresser korrigeras innan ordern skapas.",
          },
          quality: {
            title: "Ren kunddata med Adresstvätt",
            description: "Tvätta era kundregister regelbundet med Adresstvätt. Håll er CRM-data ren och uppdaterad för bättre marknadsföring och leveransprecision.",
          },
        },
      },
      products: {
        title: "Tjänster för e-handel",
        subtitle: "Allt ni behöver för korrekt adressdata och optimerad leveranslogistik.",
        items: {
          atlas: {
            name: "Atlas",
            description: "Definiera leveranszoner per region eller fraktsätt med postnummerytor som grund. Se era leveransområden på kartan och optimera er fraktstruktur.",
          },
          valid: {
            name: "Valid",
            description: "Integrera adressvalidering direkt i er kassa. Ge kunden rätt adressförslag och undvik leveransproblem från start.",
          },
          adresstwatt: {
            name: "Adresstvätt",
            description: "Kvalitetssäkra era kundregister och håll er data fräsch. Perfekt för regelbunden rensning inför kampanjer och utskick.",
          },
        },
      },
      cta: {
        title: "Redo att förbättra er leveransprecision?",
        subtitle: "Boka en demo och se hur Geposit kan hjälpa er e-handel att minska returer och validera adresser i realtid.",
      },
    },
  },
  socialProof: {
    logoTitle: "Över 900 företag litar på Geposit",
    title: "Vad våra kunder säger",
    subtitle: "Vi hjälper ledande nordiska företag att ta kontroll över sin geografi.",
    testimonials: {
      first: {
        quote:
          "Nu har vi mycket färre områden där vi inte har täckning för våra tjänster. Innan hade vi 'blind spots' på delar som vi annars hade kunnat leverera till. Översikten i Atlas har gjort våra upptagningsområden både tydligare och enklare.",
        author: "Björn Nilsson",
        company: "Systemansvarig Webb, Elon",
      },
      second: {
        quote:
          "Smidig tjänst för att specificera leveransområden och dela in dessa i olika zoner. Enkelt att exportera postnummerlistor för varje område.",
        author: "Julian Lee",
        company: "Founder, Airmee",
      },
    },
  },
  customerCases: {
    hero: {
      title: "Kundcase",
      subtitle: "Se hur nordiska företag använder Geposit för att optimera sin geografi, minska returer och effektivisera sin logistik.",
    },
    logos: {
      title: "Företag som använder Geposit",
      subtitle: "Över 900 företag, organisationer och myndigheter litar på vår data.",
    },
    featured: {
      tagline: "Kundcase",
      title: "Snabbare leveranser för marknadsledaren",
      company: "Best Transport",
      companyDesc: "Marknadsledande aktör på snabba leveranser i Norden.",
      description: "Best Transport är en marknadsledande aktör på snabba leveranser i Norden. För att möta sina kunders krav på snabba och träffsäkra leveranser, ställs höga krav på välplanerade och tydliga geografiska zoner. Utmaningen låg i att hantera hundratals olika tjänster som överlappar varandra inom varje område, utan att tappa kontroll eller effektivitet.",
      result: "Med hjälp av karttjänsten Atlas som ett enhetligt planeringsverktyg kunde Best Transport skapa både en bättre översikt samt optimala distributionszoner. Resultatet blev högre fyllnadsgrad i fordonen och därmed en förbättrad lönsamhet, minskade koldioxidutsläpp – och nöjdare kunder!",
      stats: {
        efficiency: {
          value: "Fyllnadsgrad",
          label: "Högre fyllnadsgrad i fordonen",
        },
        emissions: {
          value: "CO₂",
          label: "Minskade koldioxidutsläpp",
        },
        satisfaction: {
          value: "Nöjdhet",
          label: "Nöjdare slutkunder",
        },
      },
      bullets: {
        challenge: "Komplex zonstruktur med många överlappande tjänster",
        solution: "Atlas som enhetligt planeringsverktyg för zonindelning",
        outcome: "Optimala distributionszoner med högre fyllnadsgrad",
      },
    },
    testimonials: {
      title: "Vad våra kunder säger",
      elon: {
        quote: "Nu har vi mycket färre områden där vi inte har täckning för våra tjänster. Innan hade vi 'blind spots' på delar som vi annars hade kunnat leverera till. Översikten i Atlas har gjort våra upptagningsområden både tydligare och enklare.",
        author: "Björn Nilsson",
        role: "Systemansvarig Webb",
        company: "Elon",
      },
      airmee: {
        quote: "Smidig tjänst för att specificera leveransområden och dela in dessa i olika zoner. Enkelt att exportera postnummerlistor för varje område.",
        author: "Julian Lee",
        role: "Founder",
        company: "Airmee",
      },
    },
    cta: {
      title: "Vill du bli nästa framgångshistoria?",
      subtitle: "Boka en demo och se hur Geposit kan effektivisera just er verksamhet.",
      button: "Boka demo",
    },
  },
  cta: {
    title: "Redo att ta kontroll?",
    subtitle:
      "Prata med oss om hur Geposit kan hjälpa er verksamhet att optimera geografi och adresskvalitet.",
    form: {
      company: "Företagsnamn",
      name: "Namn",
      email: "E-post",
      role: "Roll",
      interest: "Vad vill du veta mer om?",
      interestOptions: {
        atlas: "Atlas – Geografiska områden",
        valid: "Valid – Adressvalidering",
        adresstwatt: "Adresstvätt – Adressrengöring",
        general: "Generell information",
      },
      message: "Meddelande (valfritt)",
      submit: "Skicka förfrågan",
      success: "Tack för din förfrågan! Vi återkommer till dig inom kort.",
    },
  },
  footer: {
    description:
      "Geposit är Nordens ledande plattform för adress- och geodata. Med korrekt och uppdaterad grunddata erbjuder vi webbaserade tjänster och integrationer via API.",
    quickLinks: "Snabblänkar",
    products: "Tjänster",
    contact: "Kontakt",
    address: "Biblioteksgatan 29, 114 35 Stockholm",
    email: "info@geposit.se",
    partOf: "En del av Progrits",
    progritsDesc:
      "Sedan 2015 är Geposit en del av Progrits – en internationell mjukvarukoncern med inriktning mot e-handel, logistik och fordon.",
    sister: "Systerbolag",
    postnummerservice: "Postnummerservice",
    postnummerserviceDesc:
      "Postnummerservice har sedan 2005 hjälpt privatpersoner, företag och organisationer i Norden med korrekt och uppdaterad adress-, postnummer- och geodata.",
    ecoroute: "Ecoroute",
    ecorouteDesc:
      "Ecoroute erbjuder smarta ruttplanerings- och optimeringslösningar för transport- och servicebolag som vill köra effektivare, mer hållbart och med högre lönsamhet.",
    copyright: "© 2026 Geposit AB. Alla rättigheter förbehållna.",
    privacy: "Integritetspolicy",
    terms: "Villkor",
  },
  about: {
    hero: {
      title: "Om Geposit",
      subtitle: "Från svensk återförsäljare till nordiskt SaaS-bolag inom geodata",
    },
    story: {
      title: "Vår historia",
      p1: "Geposit är en nordisk leverantör av digitala tjänster inom adress- och geodata. Vår resa började 2005 under namnet Postnummerservice, då vi levererade uppdaterad adress- och postnummerdata till våra kunder. Med tiden har vi utvecklats tillsammans med våra kunder och deras behov.",
      p2: "2010 lanserade vi automatisk adresskontroll och året därpå kom vår första digitala karttjänst för zonindelning. Idag erbjuder vi digitala tjänster som förenklar, kvalitetssäkrar och automatiserar hanteringen av adresser och geografisk data.",
      p3: "Idag används våra tjänster av företag i hela Norden. Oavsett om du behöver adress- och datarensning, smart zonindelning eller geodatatjänster via API, bygger våra lösningar alltid på korrekt och uppdaterad grunddata.",
    },
    data: {
      title: "Nordens mest pålitliga adressdata",
      description: "Visste du att adresser och postnummer förändras varje vecka? Nya bostadsområden växer fram, vägar byggs om och städer förändras. Varje år uppdateras ca 250 000 adresser och postnummer i Sverige, vilket påverkar uppemot en halv miljon människor. Det gör adresser och postnummer till en färskvara som snabbt blir inaktuell.",
      description2: "På Geposit samlar vi kontinuerligt in och bearbetar data från pålitliga och officiella grundkällor som nationella postoperatörer, lantmäterier och myndigheter. Tack vare den höga kvaliteten i våra dataleveranser är vi idag en uppskattad partner till över 900 företag, organisationer och myndigheter.",
      stats: {
        customers: "+5 000",
        customersLabel: "Nöjda kunder sedan 2005",
        countries: "4",
        countriesLabel: "Nordiska länder",
        addresses: "250 000",
        addressesLabel: "Adressförändringar per år i Sverige",
      },
    },
    values: {
      title: "Vi drivs av",
      innovation: {
        title: "Teknisk innovation",
        description: "Vi utvecklar ständigt nya lösningar med kundens nytta i centrum. Vår teknik bygger på pålitlig och uppdaterad grunddata.",
      },
      trust: {
        title: "Tillit och samarbete",
        description: "Vi tror att tillit, inkludering och ett uppmuntrande klimat leder till engagemang och gemensam framgång.",
      },
      quality: {
        title: "Kvalitet i varje detalj",
        description: "Vår data uppdateras varje vecka från officiella grundkällor. Vi kompromissar aldrig med kvaliteten.",
      },
    },
    progrits: {
      title: "En del av Progrits",
      description: "Sedan 2015 är Geposit en del av Progrits – en internationell företagsgrupp inom nischad mjukvara och informationstjänster för business to business. Progrits förvärvar, utvecklar och stärker bolag för att de ska kunna göra det som de är bäst på.",
      description2: "Inom Progrits samarbetar vi med andra B2B-bolag för att skapa starkare kunderbjudanden och bättre arbetssätt. Geposit ingår i fokusområdet Transportation & Logistics tillsammans med systerbolaget Postnummerservice.",
      tagline: "Software. Brains. Grit.",
      link: "Besök progrits.se",
    },
    postnummerservice: {
      title: "Systerbolag: Postnummerservice",
      description: "Postnummerservice har sedan 2005 hjälpt privatpersoner, företag och organisationer i Norden genom att tillhandahålla korrekt och uppdaterad adress-, postnummer- och geodata. Tillsammans med Postnummerservice tillhandahåller vi flera moderna tjänster byggda på pålitlig adress- och geodata.",
      description2: "Postnummerservice samlar och bearbetar data från pålitliga grundkällor som nationella postoperatörer, lantmäterier och officiella myndigheter. Data uppdateras varje vecka för att garantera hög kvalitet och träffsäkerhet.",
      link: "Besök postnummerservice.se",
    },
    certifications: {
      title: "Certifieringar",
      subtitle: "Vi arbetar systematiskt med kvalitet, miljö och informationssäkerhet.",
      iso9001: {
        title: "ISO 9001",
        description: "Kvalitetsledning",
      },
      iso14001: {
        title: "ISO 14001",
        description: "Miljöledning",
      },
      iso27001: {
        title: "ISO 27001",
        description: "Informationssäkerhet",
      },
    },
    careers: {
      title: "Bli en del av Geposit",
      description: "Vi växer och söker alltid efter nya talanger. Vi som arbetar här drivs av teknisk innovation, med kravet att värdet för våra kunder alltid står i centrum.",
      cta: "Karriär",
    },
  },
  information: {
    title: "Information",
    subtitle: "Nyheter, dokument och viktig information från Geposit.",
    news: {
      title: "Nyheter",
      subtitle: "Senaste nytt från Geposit – uppdateringar, förbättringar och nyheter.",
      empty: "Inga nyheter publicerade ännu.",
    },
    documents: {
      title: "Dokument och villkor",
      subtitle: "Här hittar du våra allmänna villkor, policyer och andra dokument.",
    },
    quickNav: {
      news: "Nyheter",
      documents: "Dokument & villkor",
    },
    readMore: "Läs mer",
    categories: {
      villkor: "Villkor",
      policy: "Policy",
      ovrigt: "Övrigt",
    },
  },
  cookieBanner: {
    title: "Vi använder cookies",
    description: "Vi använder cookies för att förbättra din upplevelse på vår webbplats, analysera trafik och anpassa innehåll.",
    readMore: "Läs vår cookiepolicy",
    accept: "Acceptera",
    reject: "Avvisa",
  },
  cookiePolicy: {
    title: "Cookiepolicy",
    lastUpdated: "Senast uppdaterad: 2024-03-18",
    intro: "Vi samlar in information med hjälp av teknologi så som cookies (t.ex. på din webbläsare eller enhet). Cookies används för att lagra och ta emot id:n och annan information på datorer, telefoner och andra enheter. Cookies kan till exempel hjälpa oss att känna igen dig nästa gång som du besöker vår hemsida, men också möjliggöra för oss att erbjuda en säkrare och mer driftsäker tjänst.",
    purposeTitle: "Vi använder cookies för följande ändamål",
    types: {
      functional: {
        title: "Funktionella cookies",
        description: "Vi använder funktionella cookies för att hantera vissa funktioner på våra sidor, så att dina val och inställningar kommer att kommas ihåg när du kommer tillbaka till hemsidan.",
      },
      analytics: {
        title: "Cookies för analys",
        description: "Vi använder cookies för analys för att mäta hur våra tjänster efterfrågas, används och fungerar när de används. Den information som vi samlar används för att underhålla och förbättra vår tjänst.",
      },
      thirdParty: {
        title: "Cookies från tredje part",
        description: "Vi kan också tillåta våra samarbetspartners att använda cookies i våra tjänster för samma syften som beskrevs ovan. Vi kan också låta tredje parter som erbjuder tjänster för vår räkning använda cookies för de syften som beskrevs ovan.",
      },
    },
    managingTitle: "Hantera cookies",
    managingText: "De flesta webbläsare låter användaren välja hur cookies ska hanteras. Du kan då ställa in webbläsaren att vägra ta emot cookies, eller att ta bort vissa cookies. Här hittar du information om hur du hanterar cookies i din webbläsare:",
    blockingWarning: "Om du väljer att blockera cookies kan delar av vår tjänsts funktionalitet försämras eller försvinna, eftersom den förutsätter att cookies tillåts.",
    changesTitle: "Ändringar i denna policy",
    changesText: "Geposit kan från tid till annan komma att ändra denna cookiepolicy vid förändrade rutiner för användning av cookies och behandling av data samt för att följa lagstadgade krav.",
    contactTitle: "Frågor",
    contactText: "Om du har några frågor eller funderingar om vår användning av cookies, kontakta oss.",
  },
  notFound: {
    title: "404",
    message: "Sidan kunde inte hittas",
    backHome: "Tillbaka till startsidan",
  },
  kontakt: {
    title: "Kontakt",
    hero: {
      title: "Hur kan vi hjälpa dig?",
      subtitle: "Boka en kostnadsfri demo eller kontakta oss med dina frågor – vi hjälper dig att hitta rätt lösning.",
    },
    types: {
      demo: {
        title: "Boka demo",
        description: "Få en kostnadsfri genomgång av våra tjänster, anpassad efter er verksamhet.",
      },
      contact: {
        title: "Kontakta oss",
        description: "Har du frågor om våra tjänster, priser eller samarbeten? Hör av dig!",
        general: "Allmänna frågor",
        support: "Teknisk support",
      },
    },
    contactInfo: {
      title: "Kontaktuppgifter",
    },
    form: {
      titleDemo: "Boka en kostnadsfri demo",
      subtitleDemo: "Fyll i formuläret så kontaktar vi dig för att boka en tid som passar.",
      titleContact: "Skicka ett meddelande",
      subtitleContact: "Beskriv ditt ärende så återkommer vi så snart vi kan.",
      submitDemo: "Boka demo",
      submitting: "Skickar...",
      success: "Tack! Vi har tagit emot ditt meddelande och återkommer inom kort.",
      error: "Något gick fel. Försök igen eller kontakta oss via e-post.",
      interestLabel: "Vad gäller ditt ärende?",
      demoInterestLabel: "Vilken tjänst vill du boka demo för?",
      phone: "Telefonnummer",
      placeholders: {
        company: "Företag AB",
        name: "Anna Andersson",
        email: "anna@foretag.se",
        role: "Logistikchef",
        phone: "070-123 45 67",
        interest: "Välj ett alternativ",
        messageDemo: "Berätta gärna kort om er verksamhet och vad ni vill se i demon...",
        messageContact: "Berätta gärna mer om ert ärende...",
      },
    },
  },
  illustrations: {
    keyFactors: "Nyckelfaktorer",
    joinCompanies: "Anslut er till 900+ företag som redan använder Geposit",
    zoneA: "Zon A",
    zoneB: "Zon B",
    zoneC: "Zon C",
    searchAddress: "Sök adress…",
    processing: "Bearbetar…",
    completed: "klara",
    analysisResult: "Analysresultat",
    addresses: "adresser",
    correctedAddresses: "Korrigerade adresser",
    addressFile: "adresstvätt.csv",
  },
  seo: {
    tagline: "Geografisk kontroll över din verksamhet",
    home: "Geposit erbjuder adressvalidering, adresstvätt och geografisk områdesindelning för hela Norden. Moderna tjänster byggda på korrekt och uppdaterad data.",
    losningar: "Lösningar för företag som arbetar med transport, fältservice och e-handel. Validera adresser, skapa zoner och optimera era flöden med Geposit.",
    losningarTransport: "Adressvalidering och zonindelning för transportbolag och speditörer. Skapa fraktzoner, optimera rutter och säkerställ korrekta leveransadresser.",
    losningarService: "Hantera serviceområden och fältpersonal med Geposit. Skapa ansvarsområden på karta och validera adresser för servicetekniker i Norden.",
    losningarEcommerce: "Adressvalidering och leveranskontroll för e-handlare. Minska returer och felaktiga leveranser med Geposits API och adresstvätt.",
    produkter: "Geposits tjänster: Atlas för kartbaserad områdesindelning, Valid för adressvalidering via API och Adresstvätt för registervård i Norden.",
    atlas: "Atlas – Geposits karttjänst för geografisk områdesindelning. Skapa säljdistrikt, fraktzoner och serviceområden baserat på postnummer och geodata.",
    valid: "Valid – API för adressvalidering och postnummerkontroll i Sverige, Norge, Danmark och Finland. Autocomplete och realtidskontroll av adresser.",
    adresstwatt: "Tvätta och kvalitetssäkra era adressregister i Norden. Geposits Adresstvätt analyserar och rättar felaktiga adresser och postnummer automatiskt.",
    kundcase: "Se hur 900+ företag använder Geposit för geografisk kontroll, bättre adresskvalitet och optimerade leveransområden i Norden.",
    information: "Nyheter, uppdateringar och dokument från Geposit om geografisk data, adresskvalitet och områdeshantering i Norden.",
    nyheter: "Nyheter och uppdateringar från Geposit om adressvalidering, nya funktioner och förändringar i nordiska adressdata.",
    villkor: "Allmänna villkor för Geposit AB. Information om licens, ansvar och användning av våra tjänster och API:er.",
    bestall: "Beställ Geposits tjänster: Atlas, Valid och Adresstvätt. Välj det paket som passar ert behov för adresshantering i Norden.",
    omGeposit: "Geposit är Nordens ledande geodataplattform. Sedan 2016 hjälper vi företag med adressvalidering och geografisk analys. Del av Progrits-gruppen.",
    kontakt: "Kontakta Geposit AB i Stockholm. Vi hjälper dig med adressvalidering, områdesindelning och geodatatjänster för Norden.",
    integritetspolicy: "Geposits integritetspolicy. Så hanterar vi personuppgifter i enlighet med GDPR.",
    developer: "API-dokumentation och utvecklarresurser för Geposits Valid API. Integrera adressvalidering och postnummerkontroll i ert system.",
  },
  developer: {
    title: "Developer",
    subtitle: "API-dokumentation och manualer för att integrera Geposits tjänster i era system.",
    cards: {
      validApi: {
        title: "Valid API",
        description: "Dokumentation för Valids adressvaliderings-API. Validera, korrigera och berika adresser i realtid via REST.",
        cta: "Öppna dokumentation",
      },
      atlasApi: {
        title: "Atlas API",
        description: "Teknisk referens för Atlas API. Hämta och hantera geografiska områden, attribut och punkter programmatiskt.",
        cta: "Öppna API-referens",
      },
      atlasManual: {
        title: "Atlas Manual",
        description: "Användarguide för Atlas webbgränssnitt. Lär dig skapa områden, visualisera data och dela kartor.",
        cta: "Öppna manual",
      },
    },
  },
  order: {
    pageTitle: "Beställ",
    pageDescription: "Beställ Atlas eller Valid från Geposit. Konfigurera paket, tillval och ange kund- och fakturauppgifter.",
    selectProduct: "Välj produkt",
    selectProductDesc: "Vilken produkt vill du beställa?",
    chooseThis: "Välj denna",
    configureAtlas: "Konfigurera Atlas",
    configureAtlasDesc: "Välj paket och konfigurera ditt abonnemang.",
    configureValid: "Konfigurera Valid",
    configureValidDesc: "Välj paket och eventuella tillval.",
    choosePlan: "Välj paket",
    perMonth: "/mån",
    binding12: "12 mån bindningstid",
    binding3: "3 mån bindningstid",
    perMonthShort: "mån",
    adminUsers: "Admin-användare",
    adminUsersDesc: "1 ingår i paketet. Extra: 295 SEK/mån",
    viewerUsers: "Titt-användare",
    viewerUsersDesc: "0 ingår. Extra: 95 SEK/mån",
    maps: "Kartor",
    mapsDesc: "1 ingår i paketet. Extra: 495 SEK/mån",
    countries: {
      title: "Länder",
      desc: "Minst 1 land måste väljas. Första ingår, extra: 1 000 SEK/mån",
      se: "Sverige",
      no: "Norge",
      dk: "Danmark",
      fi: "Finland",
    },
    routing: {
      title: "Routing-tillägg",
      desc: "Lägg till Routing för körvägsberäkning och räckviddsanalys direkt i Atlas.",
      includedNote: "Routing Small ingår utan extra kostnad i Atlas Medium och Medium 3-mån. Du kan uppgradera till Medium eller Large om du behöver fler beräkningar.",
      nonePrice: "Inget tillägg",
      included: "Ingår",
      upgradeNote: "uppgradering",
      tiers: {
        none: { name: "Inget", short: "Utan Routing" },
        small: { name: "Small", short: "Körtid mellan 2 punkter + räckviddsområden" },
        medium: { name: "Medium", short: "Multi-stopp, avancerade fordon, fler beräkningar" },
        large: { name: "Large", short: "Högsta volymer för storskalig planering" },
      },
    },
    addons: "Tillval",
    addonsDesc: "Välj vilka tillägg du vill ha utöver grundpaketet.",
    webPortal: {
      label: "Jag vill ha tillgång till webbportal för att söka adresser manuellt",
      desc: "Ange vilka personer som ska få inloggning till söktjänsten i webbgränssnittet.",
      usersDesc: "Lägg till de personer som ska ha tillgång till webbportalen (max 10 st).",
      addUser: "Lägg till person",
    },
    userDetails: "Användaruppgifter",
    userDetailsDesc: "Ange namn, e-post och roll för varje användare.",
    adminUser: "Admin-användare",
    viewerUser: "Titt-användare",
    userName: "Namn",
    userNamePlaceholder: "Förnamn Efternamn",
    userEmail: "E-postadress",
    userEmailPlaceholder: "namn@foretag.se",
    userRole: "Roll",
    userRolePlaceholder: "t.ex. Områdesansvarig",
    noUsersNeeded: "Inga användaruppgifter behövs för denna produkt.",
    customerDetails: "Kund- & fakturauppgifter",
    customerDetailsDesc: "Fyll i era kontakt-, företags- och fakturauppgifter.",
    contactInfo: "Kontaktuppgifter",
    firstName: "Förnamn",
    lastName: "Efternamn",
    phone: "Telefon",
    email: "E-postadress",
    companyInfo: "Företagsuppgifter",
    companyName: "Företagsnamn",
    orgNumber: "Organisationsnummer",
    orgNumberHint: "10 siffror, fyll med nollor vid behov",
    address: "Adress",
    postalCode: "Postnummer",
    city: "Ort",
    country: "Land",
    billingInfo: "Fakturauppgifter",
    copyFromCompany: "Kopiera från företagsuppgifter",
    billingAddress: "Faktureringsadress",
    reference: "Er referens",
    referenceHint: "T.ex. namn på kontaktperson",
    poNumber: "Referens/PO-nummer",
    poNumberHint: "T.ex. internt inköpsnummer. Om ni önskar byta PO-nummer i framtiden så måste ni meddela oss.",
    invoiceMethod: "Metod för faktura",
    invoiceMethods: {
      email: "E-post",
      einvoice: "E-faktura",
      letter: "Brev",
    },
    invoiceEmail: "E-postadress för faktura",
    peppolId: "PEPPOL-ID",
    peppolIdHint: "Om inget PEPPOL-ID, välj annat alternativ",
    letterNotice: "Fakturan skickas till angiven faktureringsadress. Fakturaavgift tillkommer.",
    vatNumber: "VAT-nummer",
    termsPrefix: "Jag godkänner",
    termsLink: "köpvillkoren",
    summary: "Sammanfattning",
    basePlan: "(grundpaket)",
    total: "Totalt",
    validAddonsNote: "Tillvalspriserna är per styck och tillkommer utöver grundpaketet.",
    step: "Steg",
    back: "Tillbaka",
    next: "Nästa",
    submitOrder: "Slutför beställning",
    submitting: "Skickar...",
    reviewTitle: "Granska din beställning",
    reviewDesc: "Kontrollera att all information stämmer innan du slutför beställningen.",
    reviewProduct: "Beställning",
    reviewProductLabel: "Produkt",
    reviewConfirmNote: "Genom att slutföra beställningen bekräftar du att uppgifterna ovan är korrekta. Du kommer att få en orderbekräftelse via e-post.",
    saveSection: "Spara",
    confirmationTitle: "Tack för din beställning!",
    confirmationDesc: "Vi har mottagit din beställning och återkommer inom kort med en bekräftelse via e-post.",
    orderNumberLabel: "Ordernummer",
    confirmationProductLabel: "Beställd produkt",
    confirmationEmailSent: "Bekräftelse skickad",
    confirmationEmailSentDesc: "En orderbekräftelse har skickats till {{email}}.",
    confirmationNextStep: "Vad händer nu?",
    confirmationNextStepDesc: "Vi behandlar din beställning och återkommer så snart som möjligt med mer information.",
    backToHome: "Tillbaka till startsidan",
    errorTitle: "Något gick fel",
    errorDesc: "Din beställning kunde inte skickas. Vänligen försök igen eller kontakta oss.",
    adresstwatt: {
      formTitle: "Förfrågan om adresstvätt",
      formDesc: "Berätta om ert behov så kontaktar vi er med ett förslag.",
      tabContact: "Kontaktuppgifter",
      tabBilling: "Kund- & fakturauppgifter",
      messageLabel: "Beskriv ert behov",
      messagePlaceholder: "T.ex. antal adresser, vilken typ av data, tidsplan...",
      billingInfoNote: "Du behöver inte fylla i detta nu. Vi kan be dig komplettera dessa uppgifter efter att vi pratat med dig.",
      confirmationTitle: "Tack för din förfrågan!",
      confirmationDesc: "Vi har mottagit din förfrågan om adresstvätt och återkommer inom kort.",
      confirmationNextStepDesc: "Vi analyserar ditt behov och kontaktar dig med ett förslag och prisuppgifter.",
    submitRequest: "Skicka förfrågan",
    },
    share: "Dela",
    shareOrder: "Dela beställning",
    shareCopied: "Länk kopierad!",
    shareCopiedDesc: "Konfigurationslänken har kopierats till urklipp.",
    shareFullCopied: "Beställningslänk kopierad!",
    shareFullCopiedDesc: "Länken innehåller alla uppgifter. Kunden behöver bara godkänna villkoren.",
    sharedBanner: "Den här beställningen har förberetts åt dig. Granska valen och gå vidare för att slutföra.",
    sharedFullBanner: "Beställningen har fyllts i åt dig. Granska uppgifterna, godkänn villkoren och skicka.",
  },
};
